import React from "react";
import acronym from "utils/acronym";
import useTwColorByName from "utils/hooks/useTwColorByName";
import Avatar from "./Avatar";
import { USER_SYS } from "constants/app.constant";
import { isStoreHubBot } from "utils/storeHube/helpers";

const STOREHUB_BOT_LOGO = `${process.env.PUBLIC_URL}/img/logo/logo-light-streamline.png`

const AvatarProfile = ({ user: userProp, sysUser = false, showFullName = false, size, shape, className }) => {

    const isBot = !sysUser && isStoreHubBot(userProp)

    const user = {
        name: sysUser ? USER_SYS.name : userProp?.name ?? 'Usuario',
        lastname: sysUser ? USER_SYS.lastname : userProp?.lastname ?? 'no encontrado',
        image: sysUser ? USER_SYS.image : userProp?.image
    }

    const { name = "", lastname = "" } = user

    let imgSrc = user.image ? user.image.split("?")[1] : null
    let image = imgSrc === 'file=' ? null : user.image


    const fullName = lastname ? name + " " + lastname : name

    const bgColor = useTwColorByName()

    const defaultAvatarProps = {
        shape: shape || 'circle',
        size: size || 30,
    }

    if (isBot) {
        const botSize = defaultAvatarProps.size
        return (
            <>
                <span
                    className={`inline-flex items-center justify-center rounded-full ${className || ''}`}
                    style={{
                        width: botSize,
                        height: botSize,
                        minWidth: botSize,
                        backgroundColor: '#ffffff',
                        border: '1px solid #e5e7eb',
                    }}
                >
                    <img
                        src={STOREHUB_BOT_LOGO}
                        alt="StoreHub Bot"
                        style={{ width: '58%', height: '58%', objectFit: 'contain' }}
                    />
                </span>
                {showFullName && <span className="m-2 font-semibold text-gray-900 dark:text-gray-100">{fullName}</span>}
            </>
        )
    }

    return (

        <>
            <Avatar
                className={`${image ? '' : bgColor(fullName)} ${className}`}
                src={image}
                {...defaultAvatarProps}
            >
                {acronym(fullName)}
            </Avatar>
            {showFullName && <span className="m-2 font-semibold text-gray-900 dark:text-gray-100">{fullName}</span>}
        </>

    )

}

export default AvatarProfile